export const FETCH_COMPLETED_TASK_LIST_REQUEST = 'FETCH_COMPLETED_TASK_LIST_REQUEST'
export const FETCH_COMPLETED_TASK_LIST_SUCCESS = 'FETCH_COMPLETED_TASK_LIST_SUCCESS'
export const FETCH_COMPLETED_TASK_LIST_FALUIRE = 'FETCH_COMPLETED_TASK_LIST_FALUIRE'
